import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1e932f44"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1e932f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports